import { Head } from "@inertiajs/react"

import { UserForm } from "@/components/admin/user-form"
import AppLayout from "@/layouts/app-layout"
import { adminUsersPath, newAdminUserPath } from "@/routes"
import type { BreadcrumbItem, RoleOption } from "@/types"

interface Props {
  roles: RoleOption[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Users", href: adminUsersPath() },
  { title: "New", href: newAdminUserPath() },
]

export default function New({ roles }: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="New User" />

      <div className="max-w-2xl space-y-6 p-6">
        <h1 className="text-2xl font-semibold">Add User</h1>
        <UserForm
          action={adminUsersPath()}
          method="post"
          roles={roles}
          submitLabel="Create User"
        />
      </div>
    </AppLayout>
  )
}
